import { render, staticRenderFns } from "./AddBatchModal.vue?vue&type=template&id=cf68ad46&scoped=true"
import script from "./AddBatchModal.vue?vue&type=script&lang=ts"
export * from "./AddBatchModal.vue?vue&type=script&lang=ts"
import style0 from "./AddBatchModal.vue?vue&type=style&index=0&id=cf68ad46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf68ad46",
  null
  
)

export default component.exports